<template>
  <div id="tableDiv" :class="{ tableLoading: tableLoading }">
   <div class="printHide"> 
    <v-data-table
    disable-page-reset
      :headers="[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Cases', value: 'noVaxCases', align: 'center'
          },
          {text: vaccinationRateLabel, value: 'withVaxCases', align: 'center'},
          {text: 'Averted', value: 'casesAverted', align: 'center'},
        ]"
      :items="items"
      dark
      :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
     :page.sync="pageNo"
     v-if="displayOutput === 'cases'"
    >
<template v-slot:item.noVaxCases="{ item }">
    <div style="text-align: center">{{ Number(item.noVaxCases).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.withVaxCases="{ item }">
    <div style="text-align: center">{{ Number(item.withVaxCases).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.casesAverted="{ item }">
    <div style="text-align: center">{{ Number(item.casesAverted).toLocaleString()  }}</div>
  </template>
    </v-data-table>

    <v-data-table
    disable-page-reset
      :headers="[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Deaths', value: 'noVaxDeaths', align: 'center'
          },
          {text: vaccinationRateLabel, value: 'withVaxDeaths', align: 'center'},
          {text: 'Averted', value: 'deathsAverted', align: 'center'},
        ]"
      :items="items"
      dark
      :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
     :page.sync="pageNo"
     v-if="displayOutput === 'deaths'"
    >
<template v-slot:item.noVaxDeaths="{ item }">
    <div style="text-align: center">{{ Number(item.noVaxDeaths).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.withVaxDeaths="{ item }">
    <div style="text-align: center">{{ Number(item.withVaxDeaths).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.deathsAverted="{ item }">
    <div style="text-align: center">{{ Number(item.deathsAverted).toLocaleString()  }}</div>
  </template>
    </v-data-table>


   </div>
   <div class="printShow"> 
    <v-data-table
    disable-page-reset
      :headers="[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Cases', value: 'noVaxCases', align: 'center'
          },
          {text: vaccinationRateLabel, value: 'withVaxCases', align: 'center'},
          {text: 'Averted', value: 'casesAverted', align: 'center'},
        ]"
      :items="items"
      dark
      :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
      :items-per-page="100"
     :page.sync="pageNo"
     disable-pagination
     v-if="displayOutput === 'cases'"
    >
<template v-slot:item.noVaxCases="{ item }">
    <div style="text-align: center">{{ Number(item.noVaxCases).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.withVaxCases="{ item }">
    <div style="text-align: center">{{ Number(item.withVaxCases).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.casesAverted="{ item }">
    <div style="text-align: center">{{ Number(item.casesAverted).toLocaleString()  }}</div>
  </template>
    </v-data-table>


    <v-data-table
    disable-page-reset
      :headers="[
          {text: 'Site',
          align: 'start',
          sortable: true,
          value: 'name'
          },
          {text: 'Deaths', value: 'noVaxDeaths', align: 'center'
          },
          {text: vaccinationRateLabel, value: 'withVaxDeaths', align: 'center'},
          {text: 'Averted', value: 'deathsAverted', align: 'center'},
        ]"
      :items="items"
      dark
      :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
     :page.sync="pageNo"
     v-if="displayOutput === 'deaths'"
     :items-per-page="100"
     disable-pagination
    >
<template v-slot:item.noVaxDeaths="{ item }">
    <div style="text-align: center">{{ Number(item.noVaxDeaths).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.withVaxDeaths="{ item }">
    <div style="text-align: center">{{ Number(item.withVaxDeaths).toLocaleString()  }}</div>
  </template>
  <template v-slot:item.deathsAverted="{ item }">
    <div style="text-align: center">{{ Number(item.deathsAverted).toLocaleString()  }}</div>
  </template>
    </v-data-table>


   </div>
   <button v-on:click="turnPage" id="pageButton">Click Me</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

  export default {

    props: {
      items: Array
    },
    computed: {
        ...mapState(['vaccinationRateLabel','displayOutput','vaccinationGoal'])
    },
    data() {
      return {
       pageNo: 1,
       tableLoading: false,
       oldLabel: this.$store.state.vaccinationRateLabel,
       oldGoal: this.$store.state.vaccinationGoal
      }
    },
    methods: {
      turnPage() {
    this.pageNo = this.$store.state.nationPageNo;
  },
    },
    watch: {
  pageNo: function() {
    if (this.$store.state.vaccinationRateLabel === this.oldLabel && this.$store.state.vaccinationGoal === this.oldGoal) {
      this.$store.dispatch("setPageNo", this.pageNo);
    }
  },
  vaccinationRateLabel: function () {
    const temp = this.$store.state.nationPageNo;
    this.tableLoading = true;
      setTimeout(function(){ 
        this.pageNo = temp; 
        document.getElementById("pageButton").click();
        this.oldLabel = this.$store.state.vaccinationRateLabel;
        this.tableLoading = false;
        }.bind(this), 200);
  },
  vaccinationGoal: function () {
    const temp = this.$store.state.nationPageNo;
    this.tableLoading = true;
      setTimeout(function(){ 
        this.pageNo = temp; 
        document.getElementById("pageButton").click();
        this.oldGoal = this.$store.state.vaccinationGoal;
        this.tableLoading = false;
        }.bind(this), 200);
  }
}
  }
</script>